import * as React from "react"
import { CartContextSetState } from "components/cart/CartProvider"
import { CartItem } from "types/cart"

function useCartActions() {
	const dispatch = React.useContext(CartContextSetState)

	function addItem(item: CartItem) {
		dispatch({
			type: "new",
			payload: item,
		})
	}

	function removeItem(id: number) {
		dispatch({
			type: "delete",
			id,
		})
	}

	function addQuantity(id: number) {
		dispatch({
			type: "add",
			id,
		})
	}

	function subQuantity(id: number) {
		dispatch({
			type: "sub",
			id,
		})
	}

	function emptyCart() {
		dispatch({
			type: "clean",
		})
	}

	return { addItem, removeItem, addQuantity, subQuantity, emptyCart }
}

export default useCartActions
